import * as React from "react"
import { subDays, startOfToday, endOfToday } from "date-fns";
import { Component as ShadBarChart } from "../ShadBarChart";

// Kursi -  חוף כורסי
// Tsinberi - חוף צינברי
// Shikmim - חוף שיקמים

const chartConfig = {
  desktop: {
    label: "חוף כורסי",
    color: "hsl(var(--chart-1))",
  },
  mobile: {
    label: "חוף צינברי",
    color: "hsl(var(--chart-2))",
  },
  tablet: {
    label: "חוף שיקמים",
    color: "hsl(var(--chart-3))",
  }
}

function YsbBarChart({ deviceNames, dataByDuration, updateTimeBasedData }) {
  console.log(dataByDuration, "chartDataa");

  // const [activeMonth, setActiveMonth] = React.useState(deviceNames[0]);
  //   const today = startOfToday();
  //   const endToday = endOfToday();
  //   const [date, setDate] = React.useState({
  //     from: subDays(today, 7),
  //     to: endToday, // Default to a week from today
  //   });const [calenderStartDate, setCalenderStartDate] = React.useState(subDays(startOfToday(), 7));
  const [calenderStartDate, setCalenderStartDate] = React.useState(subDays(startOfToday(), 7));
  const [calenderEndDate, setCalenderEndDate] = React.useState(endOfToday);
  const [calenderComponentDisabled, setCalenderComponentDisabled] = React.useState(false);
  React.useEffect(() => {
    if (calenderComponentDisabled) {
      setCalenderComponentDisabled(false);
    }
  }, [dataByDuration]);

  React.useEffect(() => {
    updateTimeBasedData({
      from: calenderStartDate,
      to: calenderEndDate
    });
  }, []);

  const handleDateSelect = (identifier, date) => {
    if (!date) {
      console.error('Invalid date');
      return;
    }
    if (identifier === "start") {
      setCalenderStartDate(date);
    } else if (identifier === "end") {
      setCalenderEndDate(date);
    }
  };


  const result = dataByDuration.map((item, i) => {
    const reduceResult = item.result.reduce((acc, curr) => {
      const dateOnly = new Date(curr.date).toLocaleString("sv-SE", { timeZoneName: "short" }).split(" ")[0];
      acc[dateOnly] = (acc[dateOnly] || 0) + curr.entering;
      return acc;
    }, {});
    let currentDeviceName = deviceNames[i];
    return { [deviceNames[i]]: reduceResult }
  });

  //   console.log(result, "resultedData");

  const formattedResult = result.map((resultItem, i) => {
    const locationFormattedResult = Object.entries(resultItem[deviceNames[i]]).map(([date, enteringSum]) => ({
      date,
      enteringSum
    }));
    return locationFormattedResult;
  })

  //   console.log(formattedResult, "formattedResultes");

  // chartData.splice(0, chartData.length);

  const deviceTypes = ["desktop", "mobile", "tablet"];
  const chartData = [];

  formattedResult[0]?.forEach((_, index) => {
    let entry = { month: new Date(formattedResult[0][index].date).toLocaleString('he-is', { day: 'numeric', month: 'short', weekday: 'short' }) };
    formattedResult.forEach((deviceData, deviceIndex) => {
      entry[deviceTypes[deviceIndex]] = deviceData[index]?.enteringSum || 0;
    });
    chartData.push(entry);
  });

  const handleDateSubmit = () => {
    setCalenderComponentDisabled(true);
    updateTimeBasedData({
      from: calenderStartDate,
      to: calenderEndDate
    })
  }

  console.log(chartData, "chartDataut");

  //   console.log( deviceNames, dataByDuration, updateTimeBasedData, "proops");


  return (
    <ShadBarChart
      //  date={date}
      handleDateSelect={handleDateSelect}
      cardTitle={"סך כל הכניסות לחניוני חופי הכנרת"}
      cardDescription={"כניסות לפי חניון"}
      chartConfig={chartConfig}
      chartData={chartData}
      calenderStartDate={calenderStartDate}
      calenderEndDate={calenderEndDate}
      calenderComponentDisabled={calenderComponentDisabled}
      handleDateSubmit={handleDateSubmit}
      buttonText={"הצג"}

    />
  )
}


export default YsbBarChart